import type { Channel, ChannelMessage } from '@/lib/api/endpoints/channels'

/**
 * True when `next` matches `prev` on everything notification consumers render
 * (id, name, unreadCount, in order). Lets the provider keep the previous array
 * identity across poll ticks so its context memo actually holds.
 */
export function sameChannelList(prev: Channel[] | null, next: Channel[]): boolean {
  if (!prev || prev.length !== next.length) return false
  return next.every((ch, i) => {
    const p = prev[i]
    return p.id === ch.id && p.name === ch.name && (p.unreadCount ?? 0) === (ch.unreadCount ?? 0)
  })
}

export function detectUnreadDeltas(
  prevCounts: Record<string, number>,
  channels: Channel[],
): Channel[] {
  return channels.filter((ch) => (ch.unreadCount ?? 0) > (prevCounts[ch.id] ?? 0))
}

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function hasMentionOf(
  messages: ChannelMessage[],
  displayName: string,
  selfUserId: string,
): ChannelMessage | undefined {
  if (!displayName.trim()) return undefined
  const pattern = new RegExp(`@${escapeRegex(displayName)}(?:\\b|\\s|$)`, 'i')
  return messages.find(
    (m) => m.userId !== selfUserId && Boolean(m.content) && pattern.test(m.content),
  )
}
